import React from "react";

import { formatKst } from "../../utils/time";

/**
 * StaleBanner — paper-trader 통신 실패가 누적될 때 페이지 상단에 표시.
 *
 * Props:
 *   stale: bool — 3회 연속 폴링 실패 등으로 stale 판정 시 true
 *   lastUpdated: Date | null — 마지막 정상 응답 시각
 *   onRetry: () => void — 수동 재시도
 */
export default function StaleBanner({ stale, lastUpdated, onRetry }) {
    if (!stale) return null;
    const ts = lastUpdated ? formatKst(lastUpdated) : "확인 불가";
    return (
        <div
            role="alert"
            aria-live="assertive"
            className="bg-loss-subtle border border-loss-light text-loss-text px-4 py-3 rounded-md mb-4 flex items-center justify-between gap-3"
        >
            <div className="flex items-start gap-3 min-w-0">
                <span aria-hidden="true" className="text-base leading-tight">⚠</span>
                <div className="min-w-0">
                    <div className="text-sm font-semibold">
                        paper-trader 응답 없음
                    </div>
                    <div className="text-xs text-content-secondary mt-1 break-words">
                        Mac 로컬 다운 또는 SSH 터널 끊김 가능성. 마지막 정상 응답: {ts}
                    </div>
                </div>
            </div>
            {onRetry && (
                <button
                    type="button"
                    onClick={onRetry}
                    className="text-xs px-3 py-1.5 bg-surface-card border border-surface-border rounded hover:bg-surface-hover transition min-h-11 shrink-0"
                >
                    재시도
                </button>
            )}
        </div>
    );
}
